module.exports = __webpack_public_path__ + "img/logo-teach.2fd31d2b.png";